import { careerService } from "@crescentParts/Services/CareerService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface CareerFormParameter {
    FirstName: string;
    LastName: string;
    Address1: string;
    Address2: string;
    City: string;
    State: string;
    ZIP: string;
    Phone: string;
    Email: string;
    PositionDesired: string;
    HearAboutUs: string;
    Resume: any;
    onSuccess: () => void;
    onError: (error: string) => void;
}

type HandlerType = Handler<CareerFormParameter>;

export const SendData: HandlerType = async props => {
    try {
        await careerService({ careerForm: props.parameter });
        props.parameter.onSuccess();
    } catch (err) {
        if ("status" in err && err.status === 400 && err.errorJson && err.errorJson.message) {
            props.parameter.onError(err?.errorJson.message || err);
        } else {
            props.parameter.onError("");
        }
    }
};

export const chain = [SendData];

const submitCareerForm = createHandlerChainRunner(chain, "Career");
export default submitCareerForm;
